import { render, staticRenderFns } from "./websiteAdvice.vue?vue&type=template&id=9a79646a&scoped=true&"
import script from "./websiteAdvice.vue?vue&type=script&lang=js&"
export * from "./websiteAdvice.vue?vue&type=script&lang=js&"
import style0 from "./websiteAdvice.vue?vue&type=style&index=0&id=9a79646a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a79646a",
  null
  
)

export default component.exports